import React, { ReactElement } from "react"
import AcIcon from "~/components/atoms/AcIcon"
import ToggleButton from "~/components/twilio/ToggleButton"
import useDevices from "~/composable/twilio/useDevices"
import { usePermissionState } from "~/composable/twilio/usePermissionState"
import { PERMISSION_STATE } from "~/constants/twilio"

interface ToggleVideoButtonProps {
  toggleVideo: () => void
  isVideoEnabled: boolean
  disabled?: boolean
  className?: string
  children?: ReactElement | ReactElement[]
}

export default function ToggleVideoButton({
  toggleVideo,
  isVideoEnabled,
  disabled,
  className,
}: ToggleVideoButtonProps) {
  const { hasVideoInputDevices } = useDevices()
  const cameraPermission = usePermissionState("camera"  as PermissionName)

  return (
    <ToggleButton
      className={`${className || ""} ${isVideoEnabled ? "on" : "off"}`}
      onClick={toggleVideo}
      disabled={!hasVideoInputDevices || cameraPermission === PERMISSION_STATE.DENIED || disabled}
    >
      {isVideoEnabled ? <AcIcon name={"video"} /> : <AcIcon name={"video-slash"} />}
      <p className="desc">
        {!hasVideoInputDevices || cameraPermission === PERMISSION_STATE.DENIED
          ? "カメラオフ"
          : isVideoEnabled
          ? "カメラオフ"
          : "カメラオン"}
      </p>
    </ToggleButton>
  )
}
